<template>
  <div class="py-4">
    <label class="block text-gray-700 text-sm font-bold mb-2" for="username"
      >Zgjedhe llojin:</label
    >
    <div class="inline-block relative">
      <select
        class="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
        v-model="task"
        @change="changeTask"
      >
        <option></option>
        <option>Mbi/Nën ngarkesë sot</option>
        <option>8:00</option>
        <option>Email</option>
        <option>Detyrë e përbashkët</option>
        <option>Detyrë e pakryer</option>
        <option>Detyrë me prioritet AM</option>
        <option>Detyrë me prioritet PM</option>
        <!-- <option>Detyrë ditore</option> -->
        <option>Detyrë e shpejtë</option>
      </select>
      <div
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
      >
        <svg
          class="fill-current h-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path
            d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
          />
        </svg>
      </div>
    </div>
    <div v-if="task === 'Mbi/Nën ngarkesë sot'">
      <OverLoadForm />
    </div>
    <div v-if="task === '8:00'">
      <TaskForm />
    </div>
    <div v-if="task === 'Email'">
      <EmailsForm />
    </div>
    <div v-if="task === 'Detyrë e përbashkët'">
      <SimilarTasksForm />
    </div>
    <div v-if="task === 'Detyrë e pakryer'">
      <UnfinishedTasksForm />
    </div>
    <div v-if="task === 'Detyrë me prioritet AM'">
      <AmPriorityTasksForm />
    </div>
    <div v-if="task === 'Detyrë me prioritet PM'">
      <PmPriorityTasksForm />
    </div>
    <div v-if="task === 'Detyrë e shpejtë'">
      <AddFastTasksForm />
    </div>
  </div>
</template>

<script>
import OverLoadForm from "../days/OverLoadForm";
import TaskForm from "../days/TasksForm";
import EmailsForm from "../days/EmailsForm";
import SimilarTasksForm from "../days/SimilarTasksForm";
import UnfinishedTasksForm from "../days/UnfinishedTasksForm";
import AmPriorityTasksForm from "../days/AmPriorityTasksForm";
import PmPriorityTasksForm from "../days/PmPriorityTasksForm";
import AddFastTasksForm from "../days/AddFastTasksForm";
export default {
  components: {
    OverLoadForm,
    TaskForm,
    EmailsForm,
    SimilarTasksForm,
    UnfinishedTasksForm,
    AmPriorityTasksForm,
    PmPriorityTasksForm,
    AddFastTasksForm,
  },
  data() {
    return {
      task: "",
    };
  },
  methods: {
    changeTask() {
      //   console.log(this.task);
    },
  },
};
</script>

<style></style>
